module.exports = __webpack_public_path__ + "static/img/yytx20.2dc031b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx20.png
// module id = 892
// module chunks = 0